export default $axios => ({
    getProductsByIds(ids) {
        return $axios({
            method: 'GET',
            url: '/general/product-filter',
            params: {
                ids: ids,
                _: Date.now()
            }
        });
    },
    getProductsByIdsRecomended(ids) {
        return $axios({
            method: 'GET',
            url: '/general/product-filter/recommended',
            params: {
                product_ids: ids
            }
        });
    },
    postProductsCreditCalculateData(data) {
        return $axios({
            method: 'POST',
            url: '/general/v3/credits/calculate',
            data: data
        });
    },
    getProductsCreditDataByIds(ids) {
        return $axios({
            method: 'GET',
            url: '/general/credits',
            params: {
                product_ids: ids
            }
        });
    },
    getProductsAdvantages() {
        return $axios({
            method: 'GET',
            url: '/base/advantage/product_why_we/'
        });
    }
});
